var _a, _b, _c, _d, _e, _f;
import { __decorate, __metadata } from "tslib";
import { Component } from 'decorators';
import view from './guardrail.view.html';
import './guardrail.scss';
import { BuilderAiAgentService } from '../../../../../services/BuilderAiAgentService';
import TranslateService from 'modules/translate/TranslateService';
import { BlipToastService } from 'modules/shared/BlipToastService';
import { AgentSegmentService } from '../../../../services/AgentSegmentService';
import { BUILDER_AGENT_CHATHISTORY_GUARDRAIL_COPIED } from '../../../../events';
let GuardRailComponent = class GuardRailComponent {
    static $inject = ['BuilderAiAgentService', 'clipboard', 'translateService', 'BlipToastService', '$translate', 'AgentSegmentService'];
    constructor(BuilderAiAgentService, clipboard, translateService, BlipToastService, $translate, AgentSegmentService) {
        'ngInject';
        this.BuilderAiAgentService = BuilderAiAgentService;
        this.clipboard = clipboard;
        this.translateService = translateService;
        this.BlipToastService = BlipToastService;
        this.$translate = $translate;
        this.AgentSegmentService = AgentSegmentService;
        //#endregion
        //#region Properties
        this.guardrails = [];
        this.searchQuery = '';
        this.isLoading = true;
        this.onGuardrailSearch = (event) => {
            const query = (event.detail.value || '').toLowerCase();
            if (!query) {
                this.guardrails = this.guardrails.map(([key, value, _isVisible, expanded]) => [key, value, true, expanded]);
            }
            this.guardrails = this.guardrails.map(([key, value, _isVisible, expanded]) => [key, value, key.toLowerCase().includes(query), expanded]);
        };
        this.onGuardrailCopy = (guardrail, guardrailName) => {
            this.clipboard.copyText(guardrail.join('\n\n'));
            this.BlipToastService.show('success', {
                msg: this.$translate.instant('guardrail.copyGuardrailTemplate'),
            });
            this.AgentSegmentService.trackAiAgentBlock(BUILDER_AGENT_CHATHISTORY_GUARDRAIL_COPIED, { guardrailName });
        };
        this.onToggleExpand = (index) => {
            this.guardrails[index][3] = !this.guardrails[index][3];
        };
        this.loadGuardrailsTemplates();
    }
    //#region Methods
    async loadGuardrailsTemplates() {
        try {
            const currentCulture = this.translateService.getCurrentCulture();
            const result = await this.BuilderAiAgentService.getGuardrailsTemplates(currentCulture);
            if (result) {
                const templates = Object.entries(result);
                this.guardrails = templates.map(([key, value]) => [key, value, true, false]);
            }
            else {
                console.warn('No guardrails templates found.');
            }
        }
        catch (error) {
            console.error('Error loading guardrails templates:', error);
        }
        finally {
            this.isLoading = false;
        }
    }
};
//#endregion
GuardRailComponent.$inject = ['BuilderAiAgentService', 'clipboard', 'translateService', 'BlipToastService', '$translate', 'AgentSegmentService'];
GuardRailComponent = __decorate([
    Component({
        controllerAs: '$ctrl',
        template: view,
        bindings: {
            onClose: '&?',
        },
    }),
    __metadata("design:paramtypes", [typeof (_a = typeof BuilderAiAgentService !== "undefined" && BuilderAiAgentService) === "function" ? _a : Object, Object, typeof (_b = typeof TranslateService !== "undefined" && TranslateService) === "function" ? _b : Object, typeof (_c = typeof BlipToastService !== "undefined" && BlipToastService) === "function" ? _c : Object, typeof (_e = typeof angular !== "undefined" && (_d = angular.translate) !== void 0 && _d.ITranslateService) === "function" ? _e : Object, typeof (_f = typeof AgentSegmentService !== "undefined" && AgentSegmentService) === "function" ? _f : Object])
], GuardRailComponent);
export { GuardRailComponent };
